import React, {Component} from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'react-bootstrap';
import Button from './../../button/Button';

class rlModal extends Component {

    render() {
        const {
            size = 'large',
            title,
            body,
            show,
            onHide,
            className,
            hideClose
        } = this.props;

        return <Modal
                show={show}
                onHide={() => onHide()}
                className={className}
                bsSize={size}
                keyboard>
                    {title && 
                        <Modal.Header closeButton>
                            <Modal.Title>{title}</Modal.Title>
                        </Modal.Header>
                    }
                    <Modal.Body>
                        {body}
                    </Modal.Body>
                    {
                        !hideClose && (
                            <Modal.Footer>
                                <Button 
                                id="modalCloseButton"
                                onClick={()=> onHide()}
                                name="modalCloseButton"
                                >Close</Button>
                            </Modal.Footer>
                        )
                    }
                </Modal>
    }
}

rlModal.propTypes = {};

export default rlModal;